/**
 * To define all tenant id's - Supports unlimited file upload minutes
 */
 export function IsUnlimitedFileUploadMinutesAvailableForTenant(tenantId: string | undefined): boolean {
  if (tenantId != null && typeof tenantId !== "undefined" && tenantId != '' && SupportedUnlimitedFileUploadMinutesTenantList.has(tenantId)) {
    return true;
  }

  return false;
}

 const SupportedUnlimitedFileUploadMinutesTenantList: Set<string> = new Set(
   // Please add new entry in the set to enable for new tenant
  ['72f988bf-86f1-41af-91ab-2d7cd011db47',
   '42b5e100-f4cf-49ee-bbdd-b5dccb93d02f', /* test account */
  ]
);